export default "__VITE_ASSET__N2Sx5CfB__"